__turbopack_context__.v({
  "active": "ProjectCard-module__JGCjrW__active",
  "background-card": "ProjectCard-module__JGCjrW__background-card",
  "card-background-item": "ProjectCard-module__JGCjrW__card-background-item",
  "card-image": "ProjectCard-module__JGCjrW__card-image",
  "fade-in-lift": "ProjectCard-module__JGCjrW__fade-in-lift",
  "technologie-card": "ProjectCard-module__JGCjrW__technologie-card",
});
